<template>
    <v-container>
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm8 md5 elevation-6>
                <div class="sub-window">
                    <v-container pa-0 grid-list-md>
                        <v-card class="mx-auto">
                            <v-img
                                class="teal--text text--lighten-3 align-end"
                                src="@/assets/thankyou.jpg"
                                gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                :height="imgHeight"
                            >
                                <v-card-text
                                    class="teal--text text--lighten-2 text-center subtitle-1"
                                >
                                    <img
                                        height="120"
                                        :src="efectividadOrganizacionalLogo"
                                    />
                                    <br />
                                    <b
                                        >Talentwise México, Consultoría Empresarial</b
                                    >
                                </v-card-text>
                                <v-card-text class="headline text-center"
                                    >Gracias por su participación.</v-card-text
                                >
                                <v-divider class="orange lighten-1"></v-divider>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="teal lighten-3"
                                        class="text-none"
                                        text
                                        @click="onClose"
                                        >OK</v-btn
                                    >
                                </v-card-actions>
                            </v-img>
                        </v-card>
                    </v-container>
                </div>
            </v-flex>
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ThankYou',
    data() {
        return {};
    },
    created() {},
    methods: {
        onClose() {
            this.showThankYouDlg = false;
        },
    },
    computed: {
        ...mapGetters(['waitCursor', 'efectividadOrganizacionalLogo']),

        showThankYouDlg: {
            get() {
                return this.$store.getters.showThankYouDlg;
            },
            set(showThankYouDlg) {
                this.$store.dispatch('updateShowThankYouDlg', showThankYouDlg);
            },
        },

        imgHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '400px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '500px';
            } else {
                height = '600px';
            }
            return height;
        },
    },
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.9);
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>